import React, { useEffect, useState } from "react";
import { Menu, MenuItem } from 'react-pro-sidebar';
import { FaCircle } from 'react-icons/fa';
import fnc from "../mymod/commFunction";
import './MaualList.scss';

import { useDispatch, useSelector } from "react-redux";
import { setSelectedManualIndex } from "../../reduxToolkit/redux";


const MaualList = ({ closeMobileMenu, onSelectCategory, refreshKey }) => {
    const [activeMenuItem, setActiveMenuItem] = useState(null);
    const [list, setList] = useState([]);
    const dispatch = useDispatch();

    const selectedManualIndex = useSelector(state => state.appReducer.selectedManualIndex);

    useEffect(() => {
        select_board_unit1('manual');
    }, [refreshKey]);



    function select_board_unit1(kind) {
        fnc.sendAxios('/boardRoutes/select_board_unit1', { kind }, (res) => {
            if (res && Array.isArray(res)) {
                const newList = getRecords(res);
                setList(newList);
                
                // selectedManualIndex가 유효한 범위인지 확인하고, 아니면 첫 번째 항목 선택
                const validIndex = selectedManualIndex >= 0 && selectedManualIndex < newList.length ? selectedManualIndex : 0;
                const selectedItem = newList[validIndex];
                
                if (selectedItem) {
                    handleMenuClick(selectedItem);
                    // Redux 상태를 유효한 인덱스로 업데이트
                    if (validIndex !== selectedManualIndex) {
                        dispatch(setSelectedManualIndex(validIndex));
                    }
                }
            }
        });

            
        const getRecords = (res) => {
            return res.map(item => ({
                sno: item["sno"],
                unit1_code: item["unit1_code"],
                unit1_name: item["unit1_name"],
                kind: item["kind"],
                sort_order: item["sort_order"]
            }));
        };
    }

    const handleMenuClick = (item) => {
        setActiveMenuItem(item.unit1_name);
        onSelectCategory?.(item);
        closeMobileMenu?.();
        dispatch(setSelectedManualIndex(list.findIndex(i => i.sno === item.sno))); // Redux 상태 업데이트
    };

    return (
        <div className="MaualList">
            <div className="title">매뉴얼</div>
            
            <Menu>
                {list.map((item) => (
                    <MenuItem 
                        key={item.sno}
                        icon={<FaCircle size={8} />}
                        active={activeMenuItem === item.unit1_name}
                        onClick={() => handleMenuClick(item)}
                    >
                        {item.unit1_name}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default MaualList;
